/** Shared UI strings patched across all locales (hub empty state, sitemap nav, etc.) */

export type UiPatchKeys = {
  mockTestHubEmpty: string;
  mockTestHubEmptyDesc: string;
  mockTestHubLoading: string;
  popularTestsTitle: string;
  sectionSections: string;
  roundDetailStrategyTitle: string;
  navSitemap: string;
  navFaq: string;
};

const ja: UiPatchKeys = {
  mockTestHubEmpty: '現在利用可能な回がありません',
  mockTestHubEmptyDesc: 'AIが毎週新しい回を追加します。それまでセクション別練習をご利用ください。',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 人気TOEFL模試',
  sectionSections: 'セクション',
  roundDetailStrategyTitle: 'この回のセクション別戦略',
  navSitemap: 'サイトマップ',
  navFaq: 'FAQ',
};

const th: UiPatchKeys = {
  mockTestHubEmpty: 'ยังไม่มีรอบที่พร้อมใช้งาน',
  mockTestHubEmptyDesc: 'AI เพิ่มรอบใหม่ทุกสัปดาห์ ลองฝึกแยกส่วนไปก่อนได้',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 ข้อสอบ TOEFL ยอดนิยม',
  sectionSections: 'ส่วน',
  roundDetailStrategyTitle: 'กลยุทธ์แต่ละส่วนสำหรับรอบนี้',
  navSitemap: 'แผนผังเว็บไซต์',
  navFaq: 'FAQ',
};

const vi: UiPatchKeys = {
  mockTestHubEmpty: 'Chưa có đợt thi sẵn sàng',
  mockTestHubEmptyDesc: 'AI bổ sung đợt mới mỗi tuần. Trong lúc chờ, hãy luyện theo từng phần.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Đề TOEFL phổ biến',
  sectionSections: 'Phần',
  roundDetailStrategyTitle: 'Chiến lược từng phần cho đợt này',
  navSitemap: 'Sơ đồ trang',
  navFaq: 'FAQ',
};

const id: UiPatchKeys = {
  mockTestHubEmpty: 'Belum ada putaran siap',
  mockTestHubEmptyDesc: 'AI menambah putaran baru setiap minggu. Sementara latih per bagian.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Simulasi TOEFL populer',
  sectionSections: 'Bagian',
  roundDetailStrategyTitle: 'Strategi per bagian untuk putaran ini',
  navSitemap: 'Peta situs',
  navFaq: 'FAQ',
};

const zhTW: UiPatchKeys = {
  mockTestHubEmpty: '目前尚無可用回次',
  mockTestHubEmptyDesc: 'AI 每週新增回次，可先進行分項練習。',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 熱門 TOEFL 模考',
  sectionSections: '區塊',
  roundDetailStrategyTitle: '本回各區塊策略',
  navSitemap: '網站地圖',
  navFaq: 'FAQ',
};

const zhCN: UiPatchKeys = {
  mockTestHubEmpty: '目前尚无可用回次',
  mockTestHubEmptyDesc: 'AI 每周新增回次，可先进行分项练习。',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 热门 TOEFL 模考',
  sectionSections: '板块',
  roundDetailStrategyTitle: '本回各板块策略',
  navSitemap: '网站地图',
  navFaq: 'FAQ',
};

const ms: UiPatchKeys = {
  mockTestHubEmpty: 'Tiada pusingan tersedia buat masa ini',
  mockTestHubEmptyDesc: 'AI menambah pusingan baharu setiap minggu. Sementara itu, latih mengikut bahagian.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Simulasi TOEFL popular',
  sectionSections: 'Bahagian',
  roundDetailStrategyTitle: 'Strategi bahagian untuk pusingan ini',
  navSitemap: 'Peta laman',
  navFaq: 'FAQ',
};

const ptBR: UiPatchKeys = {
  mockTestHubEmpty: 'Nenhuma rodada disponível no momento',
  mockTestHubEmptyDesc: 'A IA adiciona rodadas novas toda semana. Enquanto isso, pratique por seção.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Simulados TOEFL populares',
  sectionSections: 'Seções',
  roundDetailStrategyTitle: 'Estratégias por seção desta rodada',
  navSitemap: 'Mapa do site',
  navFaq: 'FAQ',
};

const my: UiPatchKeys = {
  mockTestHubEmpty: 'လက်ရှိအသုံးပြုနိုင်သော အချိ မရှိသေးပါ',
  mockTestHubEmptyDesc: 'AI က အပတ်စဉ် အချိအသစ် ထည့်ပေးသည်။ စောင့်နေစဉ် ကဏ္ဍအလိုက် လေ့ကျင့်ပါ။',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 လူကြိုက်များသော TOEFL mock test',
  sectionSections: 'ကဏ္ဍ',
  roundDetailStrategyTitle: 'ဤအချိ၏ ကဏ္ဍအလိုက် ဗျူဟာများ',
  navSitemap: 'ဆိုဒ်မြေပုံ',
  navFaq: 'FAQ',
};

const de: UiPatchKeys = {
  mockTestHubEmpty: 'Derzeit keine Runden verfügbar',
  mockTestHubEmptyDesc: 'Die KI fügt wöchentlich neue Runden hinzu. Üben Sie bis dahin nach Abschnitt.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Beliebte TOEFL-Mock-Tests',
  sectionSections: 'Abschnitte',
  roundDetailStrategyTitle: 'Abschnittsstrategien für diese Runde',
  navSitemap: 'Seitenübersicht',
  navFaq: 'FAQ',
};

const es: UiPatchKeys = {
  mockTestHubEmpty: 'No hay rondas disponibles por ahora',
  mockTestHubEmptyDesc: 'La IA añade rondas nuevas cada semana. Mientras tanto, practica por sección.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Simulacros TOEFL populares',
  sectionSections: 'Secciones',
  roundDetailStrategyTitle: 'Estrategias por sección de esta ronda',
  navSitemap: 'Mapa del sitio',
  navFaq: 'FAQ',
};

const fr: UiPatchKeys = {
  mockTestHubEmpty: 'Aucune session disponible pour le moment',
  mockTestHubEmptyDesc: 'L’IA ajoute de nouvelles sessions chaque semaine. Entre-temps, entraînez-vous par section.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Examens blancs TOEFL populaires',
  sectionSections: 'Sections',
  roundDetailStrategyTitle: 'Stratégies par section pour cette session',
  navSitemap: 'Plan du site',
  navFaq: 'FAQ',
};

const ar: UiPatchKeys = {
  mockTestHubEmpty: 'لا توجد جولات متاحة حالياً',
  mockTestHubEmptyDesc: 'يضيف الذكاء الاصطناعي جولات جديدة أسبوعياً. في هذه الأثناء تدرّب حسب القسم.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 اختبارات TOEFL الشائعة',
  sectionSections: 'الأقسام',
  roundDetailStrategyTitle: 'استراتيجيات الأقسام لهذه الجولة',
  navSitemap: 'خريطة الموقع',
  navFaq: 'الأسئلة الشائعة',
};

const ko: UiPatchKeys = {
  mockTestHubEmpty: '현재 이용 가능한 회차를 준비 중입니다',
  mockTestHubEmptyDesc: 'AI가 매주 새 회차를 추가합니다. 그동안 섹션별 연습을 이용해 보세요.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 인기 TOEFL 모의고사',
  sectionSections: '섹션',
  roundDetailStrategyTitle: '이 회차에서 주의할 섹션별 전략',
  navSitemap: '사이트맵',
  navFaq: 'FAQ',
};

const en: UiPatchKeys = {
  mockTestHubEmpty: 'No rounds available yet',
  mockTestHubEmptyDesc: 'AI adds new rounds every week. In the meantime, try section practice.',
  mockTestHubLoading: '…',
  popularTestsTitle: '🏆 Popular TOEFL Mock Tests',
  sectionSections: 'Sections',
  roundDetailStrategyTitle: 'Section strategies for this round',
  navSitemap: 'Sitemap',
  navFaq: 'FAQ',
};

export const uiLocalePatch: Record<string, UiPatchKeys> = {
  ko, en, ja, th, vi, id, 'zh-TW': zhTW, 'zh-CN': zhCN, ms, 'pt-BR': ptBR, my, de, es, fr, ar,
};

export function applyUiLocalePatch<T extends Record<string, unknown>>(base: T, lang: string): T {
  const patch = uiLocalePatch[lang];
  if (!patch) return base;
  return { ...base, ...patch };
}
